    import React, { useEffect, useRef, useState, useLayoutEffect, useMemo } from 'react'
import { Button, Typography, Input, Divider } from 'antd'
import { FcGoogle } from "react-icons/fc";
// import logo from "../../../src/assets/logo.png"
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axiosInterceptor';
import { useAuth } from '../contexts/AuthContext';
// import Snowfall from 'react-snowfall';


export const Login = () => {
    const navigate = useNavigate();
    const { user, login: authLogin } = useAuth();
    const { Title, Text } = Typography;
    const inputRef = useRef<any>(null);

    // If already logged in (e.g. AuthContext has user), go to dashboard
    useEffect(() => {
        if (user) {
            navigate('/dashboard?tab=assessment');
        }
    }, [user, navigate]);

    // If we have a token in storage but no user yet (e.g. page refresh), verify and redirect
    useLayoutEffect(() => {
        const token = localStorage.getItem('interview_login_token') || localStorage.getItem('token');
        if (token) {
            axiosInstance.get('/auth/verify').then((response: any) => {
                if (response.data.success) {
                    navigate('/dashboard?tab=assessment');
                }
            }).catch(() => {
                navigate('/login');
            });
        }
    }, [navigate])


    useEffect(() => {
        inputRef.current?.input?.focus();
    }, [])



    const [email, setEmail] = useState<string>("")
    const [password, setPassword] = useState<string>("")

    const [authError, setAuthError] = useState<string>("")
    const [emailError, setEmailError] = useState<string>("\u200B")
    const [passwordError, setPasswordError] = useState<string>("\u200B")

    const [isInputErrorEmail, setIsInputErrorEmail] = useState<boolean>(false)
    const [isInputErrorPassword, setIsInputErrorPassword] = useState<boolean>(false)

    const[isLoading, setIsloading] = useState(false)

    useEffect(() => {
        if (email.trim()) {
            setEmailError("\u200B");
            setIsInputErrorEmail(false);
        }
    }, [email]);

    useEffect(() => {
        if (password.trim()) {
            setPasswordError("\u200B");
            setIsInputErrorPassword(false);
        }
    }, [password]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
      
        // reset errors
        setIsInputErrorEmail(false);
        setIsInputErrorPassword(false);
        setEmailError("\u200B");
        setPasswordError("\u200B");
      
        // validation
        let hasError = false;
      
        if (!email.trim()) {
          setEmailError("Email is required");
          setIsInputErrorEmail(true);
          hasError = true;
        }
      
        if (!password.trim()) {
          setPasswordError("Password is required");
          setIsInputErrorPassword(true);
          hasError = true;
        }
      
        if (hasError) return; // ⛔ stop here
      
        setIsloading(true);

        authLogin(email, password)
          .then(() => {
            navigate('/dashboard?tab=assessment');
          })
          .catch((error: any) => {
            setPasswordError(error.response?.data?.error || 'Invalid credentials');
            setIsInputErrorPassword(true);
            setIsInputErrorEmail(true);
          })
          .finally(() => {
            setIsloading(false);
          });
      };
      
      
    const snowflakeImages = useMemo(() => {
        const img = new Image();
        img.src = "https://picsum.photos/200/300";
        return [img];
      }, []);

    return (
        <div className="w-full min-h-screen flex justify-center items-center p-5">
            {/* <Snowfall snowflakeCount={100} radius={[1,10]} images={snowflakeImages}/> */}
            <div className="w-full md:w-[60%] max-w-4xl rounded-lg px-2.5 py-6 shadow-md flex flex-col md:flex-row bg-white items-stretch">
                <section className="hidden md:flex w-1/2 flex-col items-center justify-center bg-[#F4F7F9] relative">
                    {/* <ParticleBackground/> */}
                </section>
                <section className="w-full md:w-1/2 flex flex-col items-start md:pl-12 pl-5 pr-5 md:items-start items-center">
                    <div className="mt-8 md:mt-8 mt-5 flex flex-col pb-2.5 w-full pb-4">
                        <img src="https://portal.earlyjobs.ai/logo512.png" height="75px" width="75px" className="md:h-[75px] md:w-[75px] h-[60px] w-[60px]" alt="logo" />
                        <Title level={2}>Welcome Back</Title>
                        <Text>Log in to Your Account</Text>
                    </div>
                    <form className="w-full flex flex-col md:items-start items-center" onSubmit={(e) => handleSubmit(e)}>
                        <div className="w-full md:w-4/5 flex flex-col gap-px">
                            <Text type="secondary" style={{ marginBottom: "2px" }}>Email</Text>
                            <Input 
                                status={isInputErrorEmail ? "error" : ""} 
                                placeholder="Enter your email" 
                                ref={inputRef} 
                                type='email' 
                                value={email} 
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setEmail(e.target.value) }}
                                className="m-0 h-[40px] w-full"
                            />
                            <Text type='danger' style={{ margin: 0 }}>{emailError}</Text>
                        </div>

                        <div className="w-full md:w-4/5 flex flex-col gap-px">
                            <Text type="secondary" style={{ marginBottom: "2px" }}>Password</Text>
                            <Input 
                                status={isInputErrorPassword ? "error" : ""} 
                                placeholder="Enter your password" 
                                type='password' 
                                value={password} 
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setPassword(e.target.value) }}
                                className="m-0 h-[40px] w-full"
                            />
                            <Text type='danger'>{authError || passwordError}</Text>
                        </div>
                        <Button 
                            loading={isLoading} 
                            type='primary' 
                            className="w-full md:w-4/5 mt-1.5" 
                            style={{ marginTop: '5px' }} 
                            htmlType='submit'
                            onSubmit={handleSubmit}
                        >
                            Log in
                        </Button>
                        <div className="w-full md:w-4/5 flex items-center">
                            <Divider className="w-full">
                                <Text type="secondary">OR</Text>
                            </Divider>
                        </div>
                        {/* <Button 
                            icon={<FcGoogle /> as React.ReactElement} 
                            color="default" 
                            variant="outlined" 
                            className="w-4/5 sm:w-full"
                            style={{ width: "80%" }}
                        >
                            Log in with Google
                        </Button> */}
                    </form>

                    <section className="py-4 w-full md:w-4/5 flex justify-center items-center">
                         <Text>Don't have an account? <Link to="/signup">Signup</Link></Text>
                    </section>    
                </section>
            </div>
        </div>
    )
}
